import ServicePageTemplate from '../services/ServicePageTemplate';
import { seoPageData } from '../../mocks/seoPages';
const WaterHeaterInstallationPage = () => <ServicePageTemplate data={seoPageData['water-heater-installation']} />;
export default WaterHeaterInstallationPage;
